import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import { CrossCircleXs } from '@lichtblick/photon/icons/symbols/cross-circle-xs';
import { Label } from '@lichtblick/photon/molecules/label/label';
import { FieldFooter } from '@lichtblick/photon/molecules/legacy-field-footer/field-footer';
import classNames from 'classnames';
import { forwardRef, useRef } from 'react';
import { doesValueMatchSearch } from './combo-box-input.helpers';
import styles from './combo-box-input.module.scss';
import { DropDown } from './drop-down';
// FIXME: This Copy-Pasted Code within this folder only exists because the dropdown list needs a custom max-height
export const ComboBoxInput = /*#__PURE__*/ forwardRef(({ className, 'data-testid': testId, disabled, icon, id, label, name, onChange, options, statusLabel, statusType = 'default', value, ...props }, ref)=>{
    const inputRef = useRef(null);
    const dropdownRef = useRef(null);
    const inputId = id || name;
    const labelId = inputId && `${inputId}_label`;
    const statusId = inputId && `${inputId}_validationMessage`;
    const searchValue = value?.toString();
    const filteredOptions = options.filter(({ keywords, value })=>doesValueMatchSearch(value, searchValue) || keywords && doesValueMatchSearch(keywords.join(), searchValue));
    const setValue = (event)=>{
        dropdownRef.current?.open();
        onChange?.(event);
    };
    const focusInput = ()=>inputRef.current?.focus();
    const dispatchChange = (value)=>{
        onChange?.({
            target: {
                value,
                name
            }
        });
        dropdownRef.current?.close();
    };
    const openDropdown = ()=>{
        focusInput();
        dropdownRef.current?.open();
    };
    const clearInput = ()=>dispatchChange('');
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames('combo-box-input', styles.wrapper, className),
        children: [
            Boolean(label) && /*#__PURE__*/ _jsx("div", {
                className: styles['label-wrapper'],
                children: /*#__PURE__*/ _jsx(Label, {
                    bold: true,
                    htmlFor: inputId,
                    id: labelId,
                    children: label
                })
            }),
            /*#__PURE__*/ _jsxs(DropDown, {
                "aria-disabled": disabled,
                className: classNames(styles['input-row'], disabled && styles['input-row-disabled'], statusType !== 'default' && styles[`input-row-${statusType}`]),
                onClose: focusInput,
                onOptionSelect: dispatchChange,
                options: filteredOptions,
                ref: dropdownRef,
                variant: "input",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        ...props,
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        className: styles.input,
                        "data-testid": testId || inputId,
                        disabled: disabled,
                        id: inputId,
                        name: name,
                        onChange: setValue,
                        ref: (instance)=>{
                            if (typeof ref === 'function') {
                                ref(instance);
                            } else if (ref) {
                                ref.current = instance;
                            }
                            inputRef.current = instance;
                        },
                        value: value
                    }),
                    !disabled && /*#__PURE__*/ _jsxs("div", {
                        className: styles.slot,
                        children: [
                            Boolean(value) && // using `<div>` instead of `<button>` to avoid changing `:focus-within` unless `tabIndex` is explicitly set
                            /*#__PURE__*/ _jsx("div", {
                                "aria-hidden": true,
                                className: styles['icon-wrapper'],
                                onClick: clearInput,
                                children: /*#__PURE__*/ _jsx(CrossCircleXs, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                "aria-hidden": true,
                                className: styles['icon-wrapper'],
                                onClick: openDropdown,
                                children: /*#__PURE__*/ _jsx(MagnifyingGlassXs, {})
                            })
                        ]
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                icon: icon,
                id: statusId,
                label: statusLabel,
                state: statusType
            })
        ]
    });
});

//# sourceMappingURL=combo-box-input.js.map